
import AddIcon from "@mui/icons-material/Add";
import ReadMoreIcon from "@mui/icons-material/ReadMore";
import EditIcon from "@mui/icons-material/Edit"
import {CardHeader} from "@mui/material";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {generateClient} from "aws-amplify/api";
import {fetchAuthSession} from "aws-amplify/auth";
import dayjs from "dayjs";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {listBlogPosts} from "../graphql/queries";

function Projects() {
    const navigate = useNavigate();
    const [blogPosts, setBlogPosts] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        async function currentSession() {
            const {accessToken} = (await fetchAuthSession()).tokens ?? {};
            setIsAdmin(accessToken?.payload["cognito:groups"].includes("cfsAdmin"));
        }
        async function fetchData() {
            const client = generateClient();
            const resp = await client.graphql({
                query: listBlogPosts,
                authMode: "iam"
            });
            setBlogPosts(resp.data.listBlogPosts.items);
        }
        void currentSession();
        void fetchData();
    }, [navigate]);

    return (
        <section id="blog" className="content-section">
            <div className="content entire-paragraph">
                <h1 style={{textAlign: "center"}}>Projects</h1>
                <Grid container style={{marginTop: 25}}>
                    {
                        blogPosts.sort((a, b) => b.date - a.date).map((post) => (
                            <Grid item xs={12} md={6} lg={6} xl={4} key={post.id} style={{marginBottom: 50}}>
                                <Card className="card-post" sx={{maxWidth: 400}} orientation="vertical"
                                      size="md" variant="soft" style={{margin: "0 auto"}}>
                                    <CardHeader className="card-post" title={post.title}
                                                subheader={dayjs.unix(post.date).format('DD/MM/YYYY')}/>
                                    <CardMedia className="card-post" sx={{height: 350, width: 400}}>
                                        <img src={`${process.env.REACT_APP_CLOUDFRONT_DOMAIN}/public/${encodeURIComponent(post.image)}`} alt={post.image}
                                                      style={{height: 350, width: 400, objectFit: "cover"}}/>
                                    </CardMedia>
                                    <CardContent className="card-post">
                                        <Typography variant="body1">
                                            {post.short_description}
                                        </Typography>
                                    </CardContent>
                                    <CardActions className="card-post">
                                        <Button size="small" startIcon={<ReadMoreIcon/>} onClick={() =>
                                            navigate("/blog_post/" + post.id)}>
                                            Read More
                                        </Button>
                                        {
                                            isAdmin &&
                                            <Button size="small" startIcon={<EditIcon/>} onClick={() =>
                                                navigate("/blog_form/" + post.id)}>
                                                Edit Post
                                            </Button>
                                        }
                                    </CardActions>
                                </Card>
                            </Grid>
                        ))
                    }
                    {
                        isAdmin &&
                        <Grid item xs={12} md={6} lg={6} xl={4} style={{marginBottom: 50}}>
                            <Card sx={{maxWidth: 400, height: 470, display: "flex", alignItems: "center", justifyContent: "center",
                                       border: "2px dashed #ccc", cursor: "pointer", margin: "0 auto",
                                       "&:hover": {borderColor: "#999"}}}
                                  onClick={() => navigate("/blog_form")}>
                                <CardContent style={{textAlign: "center"}}>
                                    <AddIcon sx={{fontSize: 48, color: "#999"}}/>
                                    <Typography variant="h6" style={{marginTop: 8, color: "#999"}}>
                                        Add Blog Post
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    }
                </Grid>
            </div>
        </section>
    );
}

export default Projects;
